import  { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { useStore } from "effector-react";
import { $news, queryNews, queryNewsNoAcc } from "../logics/news";
import { NewsList } from "./NewsList";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import { NewsTypeList } from "./NewsTypeList";
import {
  pathNews,
  pathNewsSubAll,
  pathNewsSubImportant,
  pathNewsSubPinned,
  pathLogin,
} from "../../../common/config/vars";
import { $accounts, $selectedAccountIdx } from "../../../common/accounts2";
import { NewsNotFound } from "../atoms/NewsNotFound";
import { loggedIn } from "../../login/logics/reg";

import "../styles/news.css";
import { $SiteColors } from "../../../common/config/company-atts";

export const News = () => {
  const { accounts } = useStore($accounts);
  const accIdx = useStore($selectedAccountIdx);
  const { loaded, fail, failMsg, news } = useStore($news);
  const [showCount, setShowCount] = useState<number>(5);

  useEffect(() => {
    if (accounts.length > 0) {
      const acc = accounts[accIdx];
      queryNews({ companyId: acc.companyId, accountId: acc.id });
      localStorage.setItem("idUser", acc.id+"")
    } else {
      // console.log(localStorage.getItem("idUser"))
      if(localStorage.getItem("idUser") && localStorage.getItem("idUser")!.length!==0)
      queryNews({
        accountId: Number(localStorage.getItem("idUser")),
        companyId: 0
      });
      // queryNewsNoAcc(accounts[0].id);
    }
  }, [accounts, accIdx]);

  return !loggedIn() ? (
    <Redirect to={pathLogin} />
  ) : (
    <section className="page__content page__content_overflow">
      <h1 className="page__title" style={{color:$SiteColors.getState().titleColor}}>Новости</h1>
      <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
        {!loaded ? (
          <div className="page__data-card">
            <div className="data-card__loading-container">
              <Preloader small={true} />
              <p className="data-card__text data-card__text_loading">
                Загрузка данных...
              </p>
            </div>
          </div>
        ) : fail ? (
          <NewsNotFound text={failMsg} />
        ) : news.length === 0 ? (
          <NewsNotFound text="Новости не найдены" />
        ) : (
          <></>
        )}
        {news.length > 0 ? (
          <>
            <NewsTypeList setShowCount={setShowCount} />
            <Route exact path={pathNewsSubImportant}>
              <NewsList
                setShowCount={setShowCount}
                initShowCount={showCount}
                news={news}
                important={true}
              />
            </Route>
            <Route exact path={pathNewsSubPinned}>
              <NewsList
                setShowCount={setShowCount}
                initShowCount={showCount}
                news={news}
                pinned={true}
              />
            </Route>
            <Route exact path={pathNewsSubAll}>
              <NewsList
                setShowCount={setShowCount}
                initShowCount={showCount}
                news={news}
                all={true}
              />
            </Route>
            <Route path={pathNews}>
              <Redirect to={pathNewsSubAll} />
            </Route>
          </>
        ) : (
          <></>
        )}
      </div>
    </section>
  );
};
